import { DomeComponent, DomeManipulator, DomeRouter, ObservableValue, React } from '@lexriver/dome';
import { Settings } from '../../Settings';
import { EnumIconNames } from '../enums/EnumIconNames';

interface Attrs{
    url:string|Promise<string>
    class?:string|{[key:string]:boolean}|{[key:string]:ObservableValue<boolean>}
    style?:{[key:string]:string|number}
    iconName?:EnumIconNames
    newTab?:boolean
}

export class Link extends DomeComponent<Attrs>{
    refA!:HTMLAnchorElement
    
    render(){
        return <a ref={ref => this.refA = ref} {...this.attrs.style?{style:this.attrs.style}:null}>{this.attrs.iconName?<span class={this.attrs.iconName}/>:null}{this.children}</a>
    }

    async afterRender(){
        if(this.attrs.class){
            DomeManipulator.setCssClasses(this.refA, this.attrs.class)
            //this.refA.classList.add(this.attrs.class)
        }
        if(this.attrs.newTab){
            this.refA.setAttribute('target', '_blank')
            this.refA.setAttribute('rel', 'noopener noreferrer')
        }
        const url = Settings.addPrefixForUrl(await this.attrs.url)
        this.refA.setAttribute('href', url)
        if(!this.attrs.newTab){
            this.refA.onclick = (e) => {
                e.preventDefault()
                DomeRouter.navigate(url)
            }
        }

    }
}

